// extracted by mini-css-extract-plugin
module.exports = {"legacyChat":"LegacyPageChatbot_legacyChat__gQaR1"};